/* global $, I18n */
export default class Select2Cifra {
  constructor(element, select2Options = {}, options = {}) {
    this.element = element;
    this.select2Options = select2Options;
    this.onConnect = options.onConnect;
  }

  connect() {
    this.$element = $(this.element);
    let minimumInputLength = 0;
    if (this.$element.data('ajax--url')) {
      minimumInputLength = 3;
    }
    const multiple = this.$element.attr('multiple') !== undefined;

    const defaultOptions = {
      language: I18n.currentLocale(),
      width: '100%',
      allowClear: multiple,
      minimumInputLength,
    };

    // Si está en un modal hay un bug con select2:
    // https://select2.org/troubleshooting/common-problems#:~:text=Select2%20does%20not%20function%20properly,%22outside%20of%20the%20modal%22.
    // Si no hacemos esto, no deja coger el foco a select2
    const modal = this.element.closest('.modal-dialog');
    if (modal) {
      defaultOptions.dropdownParent = $(modal);
    }

    if (this.$element.data('select-groups') || this.select2Options.selectGroups) {
      // Renderizamos los grupos para que puedan seleccionar solo lo filtrado o todo
      defaultOptions.templateResult = this.#getTemplateSeleccionGrupos();
    }

    // Es el elemento jquery, no el objeto select2
    this.$select2 = this.$element.select2({
      ...defaultOptions, ...this.select2Options,
    });

    if (multiple) {
      this.#controlOrdenMultiple();
    }
    if (this.onConnect) {
      this.onConnect(this);
    }
  }

  disconnect() {
    this.$element.off().select2('destroy');
    this.$select2 = null;
  }

  setOptions(options) {
    // Si no quitamos las opciones, select2 añade las nuevas sin quitar las anteriores
    this.$select2.find('option, optgroup').remove();
    this.disconnect();
    this.select2Options.data = options;
    this.connect();
  }

  // Esto es porque select2 al seleccionar pone los tags múltiples ordenados
  // alfabéticamente. Esto los deja en el orden que los selecciona el usuario
  #controlOrdenMultiple() {
    this.$select2.on('select2:select', (e) => {
      const option = $(e.target).children(`[value="${e.params.data.id}"]`);
      option.detach();
      $(e.target).append(option).trigger('change');
    });
  }

  #getTemplateSeleccionGrupos() {
    return (state) => {
      if (state.element?.localName === 'optgroup') {
        const $grupoHtml = $(`
          <div class="grupo" data-nombre="${state.text}"><i class="fa fa-spell-check parcial pull-right"></i>${state.text}</div>
        `);
        $grupoHtml.on('click', () => {
          this.#seleccionarGrupo($grupoHtml, true);
        });
        $grupoHtml.find('.parcial').on('click', (e) => {
          e.stopPropagation();
          this.#seleccionarGrupo($grupoHtml, false);
        });
        return $grupoHtml;
      }
      return state.text;
    };
  }

  #seleccionarGrupo($grupo, seleccionTotal = true) {
    const searchText = _.deburr(
      this.$select2.data('select2').$container.find('.select2-search__field').val()
    ).toLowerCase();
    const groupName = $grupo.data('nombre');
    const options = this.$element.find('option');
    const groupOptions = [];
    let textMatches = 0;

    $.each(options, (key, value) => {
      // TODO: no sé si todo esto se podrá hacer con un matcher de select2, a día de hoy
      // es lo mejor que he conseguido
      const option = $(value)[0];
      const optionText = _.deburr(option.text).toLowerCase();
      if (option.parentElement.label.indexOf(groupName) >= 0) {
        groupOptions.push(option);
        if (!searchText || seleccionTotal) {
          $(value).prop('selected', 'selected');
        } else if (optionText.includes(searchText)) {
          $(value).prop('selected', 'selected');
          textMatches += 1;
        }
      }
    });

    // Segunda pasada, si hay texto de búsqueda y no hay ningún match seleccionamos todos
    // los elementos del grupo
    if (searchText && textMatches === 0) {
      $.each(groupOptions, (key, value) => $(value).prop('selected', 'selected'));
    }

    this.$element.trigger('change');
    this.$select2.select2('close');
  }
}
